import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'newBuildHouse', 'newBuildFlat',
    'propertyRefurbishment', 'propertyRefurbishmentDiv',
    'propertyOutbuildings', 'outbuildingsDiv',
    'propertyLandsize', 'landsizeDiv',
    'propertyTenure', 'propertyTenureDiv',
    'propertyTimeleft', 'propertyTimeleftDiv'
  ];

  connect() {
    this.toggleCondition();
    this.toggleOutbuildings();
    this.toggleLandsize();
    this.toggleTenure();
  }

  toggleNewBuild(event) {
    const checkbox = event.target;
    const isHouse = checkbox === this.newBuildHouseTarget;

    if (checkbox.checked) {
      if (isHouse) {
        this.newBuildFlatTarget.checked = false;
      } else {
        this.newBuildHouseTarget.checked = false;
      }
    }
  }

  toggleCondition() {
    if (!this.hasPropertyRefurbishmentTarget || !this.hasPropertyRefurbishmentDivTarget) return;

    const refurbishmentValue = this.propertyRefurbishmentTarget.value;
    if (['light', 'heavy'].includes(refurbishmentValue)) {
      this.propertyRefurbishmentDivTarget.classList.remove('hidden');
    } else {
      this.propertyRefurbishmentDivTarget.classList.add('hidden');
    }
  }

  toggleOutbuildings() {
    if (!this.hasPropertyOutbuildingsTarget || !this.hasOutbuildingsDivTarget) return;

    const value = this.propertyOutbuildingsTarget.value;
    if (value === 'true') {
      this.outbuildingsDivTarget.classList.remove('hidden');
    } else {
      this.outbuildingsDivTarget.classList.add('hidden');
    }
  }

  toggleLandsize() {
    if (!this.hasPropertyLandsizeTarget || !this.hasLandsizeDivTarget) return;

    const value = this.propertyLandsizeTarget.value;
    if (value === 'over_two_acres') {
      this.landsizeDivTarget.classList.remove('hidden');
    } else {
      this.landsizeDivTarget.classList.add('hidden');
    }
  }

  toggleTenure() {
    if (!this.hasPropertyTenureTarget || !this.hasPropertyTenureDivTarget ||
        !this.hasPropertyTimeleftTarget || !this.hasPropertyTimeleftDivTarget) return;

    const tenureValue = this.propertyTenureTarget.value;
    const timeleftValue = this.propertyTimeleftTarget.value;
    const tenure = this.propertyTenureDivTarget;
    const timeleft = this.propertyTimeleftDivTarget;

    if (tenureValue === '2' && timeleftValue === 'true') {
      tenure.classList.remove('hidden');
      timeleft.classList.remove('hidden');
    } else if (tenureValue === '2' && timeleftValue !== 'true') {
      tenure.classList.remove('hidden');
      timeleft.classList.add('hidden');
    } else {
      tenure.classList.add('hidden');
      timeleft.classList.add('hidden');
    }
  }
}
